import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractTypeService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ContractTypeCreateDto,
  ContractTypeDto,
  ContractTypeExcelDownloadDto,
  ContractTypeUpdateDto,
} from '../proxy/controlling/dtos/contract-type';
import { CONTRACTTYPE_CONFIG, CONTRACTTYPE_FIELDS } from './contract-type.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';

@Component({
  selector: 'app-contract-type',
  imports: [
    CommonModule,
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [ListService, ContractTypeService, ConfirmationService],
  templateUrl: './contract-type.html',
  styleUrl: './contract-type.scss',
})
export class ContractType extends BaseHierarchicalCrudComponent<
  ContractTypeDto,
  ContractTypeCreateDto,
  ContractTypeUpdateDto,
  ContractTypeExcelDownloadDto
> {
  service = inject(ContractTypeService);
  config = CONTRACTTYPE_CONFIG;
  fields = CONTRACTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ContractTypeDto): ContractTypeUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ContractType';
  }
}
